if (!customElements.get('mot-sticky-cart')) {
  customElements.define('mot-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      this.root = document.querySelector('main [data-product-root]');
      this.mainButton = this.root?.querySelector('button.add-to-cart');
      this.form = this.mainButton?.form;
      if (!this.form) return;
      this.product = JSON.parse(this.querySelector('[data-product-data]').textContent);
      this.add = this.querySelector('[data-add]');
      this.label = this.querySelector('[data-label]');
      this.selection = this.querySelector('[data-selection]');
      this.price = this.querySelector('[data-price]');
      this.change = this.querySelector('[data-change]');
      this.queue = () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = null; this.sync(); });
      };
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      window.addEventListener('scroll', this.queue, { ...options, passive: true });
      window.addEventListener('resize', this.queue, options);
      this.root.addEventListener('change', this.queue, options);
      this.root.addEventListener('input', this.queue, options);
      document.addEventListener('theme:variant:change', this.queue, options);
      this.change.addEventListener('click', () => window.scrollTo({ top: 0, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' }), options);
      this.add.addEventListener('click', () => {
        this.sync();
        if (this.needsOptions) return this.returnToOptions();
        if (this.mainButton.disabled || this.busy) return;
        this.busy = true;
        this.add.disabled = true;
        this.mainButton.click();
        this.unlock = setTimeout(() => { this.busy = false; this.queue(); }, 1000);
      }, options);
      this.observer = new MutationObserver(this.queue);
      this.observer.observe(this.root, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['value','checked','disabled','style','class','data-preorder'] });
      this.bodyObserver = new MutationObserver(this.queue);
      this.bodyObserver.observe(document.body, { attributes: true, attributeFilter: ['class','style'] });
      this.bodyObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
      this.timer = setInterval(this.queue, 500);
      this.sync();
    }
    displayed(el) {
      if (!el || !el.getClientRects().length) return false;
      const css = getComputedStyle(el);
      return css.display !== 'none' && css.visibility !== 'hidden' && css.opacity !== '0';
    }
    overlayOpen() {
      if (document.documentElement.classList.contains('mot-navigation-open')) return true;
      if (getComputedStyle(document.body).overflowY === 'hidden') return true;
      return [...document.querySelectorAll('#CartPopup, dialog[open], [role="dialog"][aria-modal="true"], .mot-preorder-notice:not([hidden])')].some(el => {
        const r = el.getBoundingClientRect();
        return this.displayed(el) && r.right > 0 && r.left < document.documentElement.clientWidth && r.bottom > 0 && r.top < innerHeight;
      });
    }
    sync() {
      const id = new FormData(this.form).get('id');
      const variant = this.product.variants.find(v => String(v.id) === String(id));
      const invalid = [...this.form.elements].find(e => e.willValidate && !e.validity.valid);
      this.needsOptions = !variant || Boolean(invalid);
      this.invalid = invalid;
      const quantity = new FormData(this.form).get('quantity') || '1';
      const extras = [...this.root.querySelectorAll('[data-mot-hook-selector], [data-mot-note-block-holder-selector], [data-mot-magnet-addon]')].map(group => {
        const input = group.querySelector('input:checked');
        if (!input?.value) return '';
        const label = input.labels?.[0]?.textContent.trim();
        const name = group.hasAttribute('data-mot-hook-selector') ? 'Hooks' : group.hasAttribute('data-mot-note-block-holder-selector') ? 'Holder' : 'Magnets';
        return label ? name + ': ' + label.replace(/\s+/g,' ') : name + ' included';
      }).filter(Boolean);
      const variantLabel = variant?.title === 'Default Title' ? '' : (variant?.options || []).map((value, index) => {
        if (String(value).toLowerCase() !== 'no') return value;
        const option = this.product.options[index];
        const name = String(typeof option === 'string' ? option : option?.name || '').toLowerCase();
        if (name.includes('gift box')) return 'No gift box';
        if (name.includes('monogramming')) return 'No monogramming';
        if (name.includes('laser engraving')) return 'No laser engraving';
        return value;
      }).join(' / ');
      const text = [variantLabel, ...extras, 'Qty ' + quantity].filter(Boolean).join(' · ');
      if (this.selection.textContent !== text) this.selection.textContent = text;
      const price = this.root.querySelector('#productPrice')?.textContent.trim() || '';
      if (this.price.textContent !== price) this.price.textContent = price;
      const image = this.querySelector('img');
      const src = variant?.featured_image?.src || this.product.featured_image;
      if (image && src && image.dataset.source !== src) {
        image.dataset.source = src;
        image.removeAttribute('srcset');
        image.src = src + (src.includes('?') ? '&' : '?') + 'width=120';
      }
      const originalLabel = this.mainButton.innerText.replace(/→/g,'').trim().replace(/\s+/g,' ');
      this.label.textContent = this.needsOptions ? 'Choose options' : (originalLabel || 'Add to cart');
      this.add.disabled = this.busy || (!this.needsOptions && this.mainButton.disabled);
      const rect = this.mainButton.getBoundingClientRect();
      const footer = document.querySelector('footer.mot-footer');
      const footerRect = footer?.getBoundingClientRect();
      const footerVisible = footerRect && footerRect.top < innerHeight && footerRect.bottom > 0;
      const visible = this.displayed(this.mainButton) && rect.bottom <= 0 && !footerVisible && !this.overlayOpen();
      this.hidden = document.documentElement.classList.contains('mot-navigation-open');
      this.classList.toggle('is-visible', visible);
      this.inert = !visible;
      this.setAttribute('aria-hidden', String(!visible));
      const preview = document.querySelector('#preview-bar-iframe');
      if (preview) {
        const pr = preview.getBoundingClientRect();
        this.style.bottom = this.displayed(preview) && pr.top < innerHeight ? (innerHeight - pr.top + 12) + 'px' : '';
      }
    }
    returnToOptions() {
      const target = this.invalid || this.root.querySelector('.product-variant-picker-block') || this.mainButton;
      const y = target.getBoundingClientRect().top + scrollY - 120;
      window.scrollTo({ top: Math.max(0,y), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      if (this.invalid) this.invalid.focus({ preventScroll: true });
      else target.querySelector('input,select,button')?.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      this.abort?.abort(); this.observer?.disconnect(); this.bodyObserver?.disconnect();
      clearInterval(this.timer); clearTimeout(this.unlock); cancelAnimationFrame(this.frame);
    }
  });
}

